import axios from 'axios';

const apiCep = axios.create({
  //  baseURL: 'https://opencep.com/v1',
  baseURL: 'https://viacep.com.br/ws',
});

export default apiCep;
